module.exports = __webpack_public_path__ + "static/img/title2.75e7fbf4.png";